module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('h1', {
    staticClass: "pageTitle pageTitle--light"
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n         "), (_vm.batch.status !== 'planned' && _vm.batch.batchNumber) ? _c('span', [_vm._v("#" + _vm._s(_vm.batch.batchNumber) + ":")]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.batch.name ? _vm.batch.name : _vm.$t('static.batches.view.title')) + "\n      ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.batches.formTabs.details'),
      "name": "1"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 12
    }
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              " + _vm._s(_vm.batch.status ? _vm.$t(("static.batches.statuses." + (_vm.batch.status))) : ' ') + "\n              "), ((_vm.batch.status === 'planned' || _vm.batch.status === 'started') && _vm.batch.recipe.procedures.length === 0) ? _c('el-button', {
    staticStyle: {
      "margin-left": "auto",
      "padding": "7px 12px"
    },
    attrs: {
      "loading": _vm.startBatchloading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.startBatch('started')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.batches.view.startBatch.title')))]) : _vm._e(), _vm._v(" "), (_vm.batch.status !== 'completed') ? _c('el-button', {
    staticStyle: {
      "margin-left": "auto",
      "padding": "7px 12px"
    },
    attrs: {
      "loading": _vm.completeBatchloading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.completeBatch()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.batches.view.completeBatch.title')))]) : _vm._e()], 1), _vm._v(" "), (_vm.batch.plannedStartingDate && _vm.batch.status === 'planned') ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small margin-r-10"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('static.batches.view.plannedStartingDate')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                " + _vm._s(_vm.batch.plannedStartingDate) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.batch.startDate) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small margin-r-10"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('static.batches.view.startDate')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                " + _vm._s(_vm.batch.startDate) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.batch.endDate && _vm.batch.status === 'completed') ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small margin-r-10"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('static.batches.view.endDate')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                " + _vm._s(_vm.batch.startDate) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.batch.bestBeforeDate) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('static.batches.view.bestBeforeDate')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                " + _vm._s(_vm.batch.bestBeforeDate) + "\n              ")])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 12
    }
  }, [(_vm.ongoingProcedures.length) ? _c('fieldset', {
    staticClass: "margin-b-20 margin-t-10",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('legend', [_c('b', [_vm._v(_vm._s(_vm.$t('static.batches.view.ongoingProcedures')))])]), _vm._v(" "), _vm._l((_vm.ongoingProcedures), function(procedure) {
    return _c('el-card', {
      key: procedure.id,
      staticClass: "box-card margin-b-10",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "shadow": "never"
      }
    }, [_c('div', {
      staticClass: "flex",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', [(procedure.step) ? _c('b', {
      staticStyle: {
        "font-weight": "700"
      }
    }, [_vm._v(_vm._s(_vm.$t('static.recipes.edit.step')) + "\n                      " + _vm._s(procedure.step) + " -")]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(procedure.name))])]), _vm._v(" "), (_vm.batch.status !== 'completed') ? _c('el-button', {
      staticStyle: {
        "margin-left": "auto",
        "padding": "7px 12px"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.setProcedureStatus(procedure.id, 'completed')
        }
      }
    }, [_vm._v("Complete")]) : _vm._e()], 1), _vm._v(" "), (procedure.ingrediences.length) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.ingrediences')) + " ")]) : _vm._e(), _vm._v(" "), _vm._l((procedure.ingrediences), function(ingredience) {
      return (procedure.ingrediences) ? _c('li', {
        key: ingredience.id,
        staticClass: "text item"
      }, [_c('b', [_vm._v(_vm._s(ingredience.materialName))]), _vm._v(" - " + _vm._s(ingredience.amount) + " " + _vm._s(ingredience.unitMeasure) + "\n                ")]) : _vm._e()
    }), _vm._v(" "), (procedure.equipment) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.equipment')))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(_vm._s(procedure.equipment))])], 2)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.upcomingProcedures.length) ? _c('fieldset', {
    staticClass: "margin-b-10 margin-t-10",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('legend', [_c('b', [_vm._v(_vm._s(_vm.$t('static.batches.view.upcomingProcedures')))])]), _vm._v(" "), _vm._l((_vm.upcomingProcedures), function(procedure) {
    return _c('el-card', {
      key: procedure.id,
      staticClass: "box-card margin-b-10",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "shadow": "never"
      }
    }, [_c('div', {
      staticClass: "flex",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', [(procedure.step) ? _c('b', {
      staticStyle: {
        "font-weight": "700"
      }
    }, [_vm._v(_vm._s(_vm.$t('static.recipes.edit.step')) + "\n                      " + _vm._s(procedure.step) + " -")]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(procedure.name))])]), _vm._v(" "), (_vm.batch.status !== 'completed') ? _c('el-button', {
      staticClass: "dark",
      staticStyle: {
        "margin-left": "auto",
        "padding": "7px 12px"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.batch.status !== 'ongoing' ? _vm.confirmProcedureStart(procedure.id, 'started') : _vm.setProcedureStatus(procedure.id, 'started')
        }
      }
    }, [_vm._v("Start")]) : _vm._e()], 1), _vm._v(" "), (procedure.ingrediences.length) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.ingrediences')) + " ")]) : _vm._e(), _vm._v(" "), _vm._l((procedure.ingrediences), function(ingredience) {
      return (procedure.ingrediences) ? _c('li', {
        key: ingredience.id,
        staticClass: "text item"
      }, [_c('b', [_vm._v(_vm._s(ingredience.materialName))]), _vm._v(" - " + _vm._s(ingredience.amount) + " " + _vm._s(ingredience.unitMeasure) + "\n                ")]) : _vm._e()
    }), _vm._v(" "), (procedure.equipment) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.equipment')))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(_vm._s(procedure.equipment))])], 2)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.completedProcedures.length) ? _c('fieldset', {
    staticClass: "margin-b-10 margin-t-10",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('legend', [_c('b', [_vm._v(_vm._s(_vm.$t('static.batches.view.completedProcedures')))])]), _vm._v(" "), _vm._l((_vm.completedProcedures), function(procedure) {
    return _c('el-card', {
      key: procedure.id,
      staticClass: "box-card margin-b-10",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "shadow": "never"
      }
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', [(procedure.step) ? _c('b', {
      staticStyle: {
        "font-weight": "700"
      }
    }, [_vm._v(_vm._s(_vm.$t('static.recipes.edit.step')) + "\n                      " + _vm._s(procedure.step) + " -")]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(procedure.name))])])]), _vm._v(" "), (procedure.ingrediences.length) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.ingrediences')) + " ")]) : _vm._e(), _vm._v(" "), _vm._l((procedure.ingrediences), function(ingredience) {
      return (procedure.ingrediences) ? _c('li', {
        key: ingredience.id,
        staticClass: "text item"
      }, [_c('b', [_vm._v(_vm._s(ingredience.materialName))]), _vm._v(" - " + _vm._s(ingredience.amount) + " " + _vm._s(ingredience.unitMeasure) + "\n                ")]) : _vm._e()
    }), _vm._v(" "), (procedure.equipment) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.equipment')))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(_vm._s(procedure.equipment))])], 2)
  })], 2) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 12
    }
  }, [_c('fieldset', {
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('legend', [_vm._v("Bevegelser")]), _vm._v(" "), (!_vm.bridgeStockWriteBlocked) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'inventory.transfer.create',
        query: {
          batch: _vm.batch.id
        }
      }
    }
  }, [_vm._v("\n                 "), (_vm.batch.status !== 'planned') ? _c('el-button', {
    staticClass: "small margin-b-10"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.batches.view.createBatchTransfer')) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-form-table', {
    staticClass: "batches-table",
    attrs: {
      "form": _vm.form,
      "list": _vm.tranferProducts,
      "update": _vm.update,
      "noResultWarningText": "No Result",
      "translation": "form.batch",
      "hiddenFields": ['id']
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.batches.formTabs.edit'),
      "name": "2"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('v-form', {
    attrs: {
      "save": _vm.updateBatch,
      "form": _vm.formBatchEdit,
      "translation": "form.batches",
      "hasLabel": true
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.batches.formTabs.materials'),
      "name": "3"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('v-form-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.materialsLoading),
      expression: "materialsLoading"
    }],
    attrs: {
      "form": _vm.formIngredience,
      "list": _vm.ingredienceList,
      "update": _vm.updateIngredience,
      "destroy": _vm.destroyIngredience,
      "hiddenFields": _vm.hiddenFields,
      "disabledRows": _vm.disabledItems,
      "disableForm": _vm.disableForm,
      "noResultWarningText": _vm.$t('table.recipeIngrediences.noResult'),
      "translation": "table.recipeIngrediences",
      "clickHandler": _vm.tableClickHandler,
      "clickHandlerIcon": "fa fa-plus-circle",
      "additionalButtons": _vm.additionalButtons
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.batches.formTabs.log'),
      "name": "4"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [_c('el-button', {
    staticClass: " margin-b-10 small",
    on: {
      "click": _vm.addBatchLog
    }
  }, [_vm._v(_vm._s(_vm.$t('static.batches.logs.add')))]), _vm._v(" "), _c('div', {
    staticClass: "flex stretch wrap"
  }, [(_vm.logs) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.logs.items
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "timestamp",
      "label": "Tid"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "Detaljer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userFullname",
      "label": "Bruker"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "pagination": _vm.logs.pagination,
      "switchFunction": _vm.fetchBatchLogs
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-310197d3","hasScoped":true}!./src/app/pages/withNavigation/batches/view/view.html
// module id = 2959
// module chunks = 1